const noWhiteSpaceAndSpecialChar = /^[a-zA-Z0-9]+|$/
const onlyAlphabetandSpace = /^[a-zA-Z ]*$/

const rgxExp = {
  noWhiteSpaceAndSpecialChar,
  onlyAlphabetandSpace
}

export default rgxExp
